<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="AddWorkLvScore" :model="formData" :rules="rules" class="full-width-input" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="类型" prop="PaWorkLvScore.type">
            <el-select class="input-item" v-model="formData.PaWorkLvScore.type" :clearable="true" filterable :disabled="true"
              placeholder="类型" :loading="AddWorkLvScore.type.impl.loading"
              @visible-change="AddWorkLvScore.type.impl.onVisibleChange"
              @change="onTypeValueChange">
              <el-option v-for="item in AddWorkLvScore.type.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="formData.PaWorkLvScore.type!=='post'">
          <el-form-item label="名称" prop="PaWorkLvScore.name">
            <el-input class="input-item" v-model="formData.PaWorkLvScore.name"
              :clearable="true" placeholder="名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="formData.PaWorkLvScore.type==='post'">
          <el-form-item label="作品分工" prop="PaWorkLvScore.deptPostId">
            <el-select class="input-item" v-model="formData.PaWorkLvScore.deptPostId" :clearable="true" filterable
                       placeholder="作品分工" :loading="AddWorkLvScore.deptPostId.impl.loading"
                       @visible-change="AddWorkLvScore.deptPostId.impl.onVisibleChange"
                       @change="onDeptPostIdValueChange">
              <el-option v-for="item in AddWorkLvScore.deptPostId.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="showLvA">
          <el-form-item :label="labelLvA" prop="PaWorkLvScore.lvA">
            <el-input-number class="input-item" v-model="formData.PaWorkLvScore.lvA" :clearable="true" :placeholder="labelLvA" :min="0"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="showLvB">
          <el-form-item :label="labelLvB" prop="PaWorkLvScore.lvB">
            <el-input-number class="input-item" v-model="formData.PaWorkLvScore.lvB" :clearable="true" :placeholder="labelLvB" :min="0"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="showLvC">
          <el-form-item :label="labelLvC" prop="PaWorkLvScore.lvC">
            <el-input-number class="input-item" v-model="formData.PaWorkLvScore.lvC" :clearable="true" :placeholder="labelLvC" :min="0"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="showLvD">
          <el-form-item :label="labelLvD" prop="PaWorkLvScore.lvD">
            <el-input-number class="input-item" v-model="formData.PaWorkLvScore.lvD" :clearable="true" :placeholder="labelLvD" :min="0"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="formData.PaWorkLvScore.type!=='root'">
          <el-form-item label="启用" prop="PaWorkLvScore.enableFlag">
            <el-radio-group class="input-item" v-model="formData.PaWorkLvScore.enableFlag" @change="onEnableFlagValueChange">
              <el-radio v-for="item in AddWorkLvScore.enableFlag.impl.dropdownList" :key="item.id" :label="item.id">
                {{item.name}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="formData.PaWorkLvScore.type!=='root'">
          <el-form-item label="排序" prop="PaWorkLvScore.sort">
            <el-input-number class="input-item" v-model="formData.PaWorkLvScore.sort"
                             :clearable="true"
                             placeholder="排序"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="描述" prop="PaWorkLvScore.detail">
            <el-input class="input-item" v-model="formData.PaWorkLvScore.detail"
              :clearable="true" placeholder="描述" type="textarea" :autosize="{ minRows: 4}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="PaWorkLvScore.remark">
            <el-input class="input-item" v-model="formData.PaWorkLvScore.remark"
              :clearable="true" placeholder="备注"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button type="primary" :size="defaultFormItemSize" :plain="true"
              @click="onCancel(false)">
              取消
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('AddWorkLvScore:AddWorkLvScore:add')"
              @click="onAddClick()">
              新增
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaWorkLvScoreController, DictionaryController } from '@/api';

export default {
  name: 'AddWorkLvScore',
  props: {
    // 是否支持级联操作
    supportCascadeAdd: {
      type: String,
      default: '0'
    },
    // 级联操作数据
    rowData: {
      type: Object
    },
    pid: {
      default: undefined
    },
    type: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      showLvA: false,
      showLvB: false,
      showLvC: false,
      showLvD: false,
      labelLvA: 'A级',
      labelLvB: 'B级',
      labelLvC: 'C级',
      labelLvD: 'D级',
      formData: {
        PaWorkLvScore: {
          id: undefined,
          pid: this.pid,
          tid: undefined,
          tname: undefined,
          gcode: undefined,
          code: undefined,
          type: this.type,
          name: undefined,
          detail: undefined,
          remark: undefined,
          deptPostId: undefined,
          enableFlag: 'Y',
          sort: 1,
          lvA: 0,
          lvB: 0,
          lvC: 0,
          lvD: 0,
          lvE: 0,
          lvF: 0,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          isDatasourceInit: false
        }
      },
      rules: {
        'PaWorkLvScore.name': [{required: true, message: '请输入名称', trigger: 'blur'}],
        'PaWorkLvScore.deptPostId': [{required: true, message: '请选择作品分工', trigger: 'blur'}],
        'PaWorkLvScore.lvA': [{required: true, message: '请输入A级', trigger: 'blur'}],
        'PaWorkLvScore.lvB': [{required: true, message: '请输入B级', trigger: 'blur'}],
        'PaWorkLvScore.lvC': [{required: true, message: '请输入C级', trigger: 'blur'}],
        'PaWorkLvScore.lvD': [{required: true, message: '请输入D级', trigger: 'blur'}]
      },
      AddWorkLvScore: {
        formFilter: {
        },
        formFilterCopy: {
        },
        type: {
          impl: new DropdownWidget(this.loadTypeDropdownList)
        },
        enableFlag: {
          impl: new DropdownWidget(this.loadEnableFlagDropdownList)
        },
        deptPostId: {
          impl: new DropdownWidget(this.loadDeptPostIdDropdownList)
        },
        BtnDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    /**
     * 类型下拉数据获取函数
     */
    loadTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_work_lv_score_type'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 类型选中值改变
     */
    onTypeValueChange (value) {
    },
    /**
     * 启用下拉数据获取函数
     */
    loadEnableFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYN(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 启用选中值改变
     */
    onEnableFlagValueChange (value) {
    },
    /**
     * 作品分工下拉数据获取函数
     */
    loadDeptPostIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'work_post'};
        DictionaryController.dictSysIdDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 作品分工选中值改变
     */
    onDeptPostIdValueChange (value) {
      let deptPostIdDictMap = findItemFromList(this.AddWorkLvScore.deptPostId.impl.dropdownList, this.formData.PaWorkLvScore.deptPostId, 'id')
      this.formData.PaWorkLvScore.name = deptPostIdDictMap.name;
    },
    /**
     * 更新添加作品级别分值
     */
    refreshAddWorkLvScore (reloadData = false) {
      let x = this.type === 'type' ? '(分)' : '(%)';
      this.labelLvA = this.labelLvA + x;
      this.labelLvB = this.labelLvB + x;
      this.labelLvC = this.labelLvC + x;
      this.labelLvD = this.labelLvD + x;
      if (this.type === 'type') {
        this.showLvA = this.showLvB = this.showLvC = this.showLvD = true;
      } else if (this.type === 'post') {
        PaWorkLvScoreController.view(this, {id: this.pid}).then(pres => {
          let parentItem = {...pres.data};
          this.showLvA = parentItem.lvA > 0;
          this.showLvB = parentItem.lvB > 0;
          this.showLvC = parentItem.lvC > 0;
          this.showLvD = parentItem.lvD > 0;
        });
      }
      if (!this.AddWorkLvScore.isInit) {
        // 初始化下拉数据
        this.AddWorkLvScore.enableFlag.impl.onVisibleChange(true).catch(e => {});
        this.AddWorkLvScore.type.impl.onVisibleChange(true).catch(e => {});
        this.AddWorkLvScore.deptPostId.impl.onVisibleChange(true).catch(e => {});
      }
      this.AddWorkLvScore.isInit = true;
    },
    /**
     * 新增
     */
    onAddClick () {
      this.$refs.AddWorkLvScore.validate((valid) => {
        if (!valid) return;
        // 如果是级联表格的添加或者编辑弹窗
        if (this.supportCascadeAdd === '1') {
          let formData = {
            typeDictMap: findItemFromList(this.AddWorkLvScore.type.impl.dropdownList, this.formData.PaWorkLvScore.type, 'id'),
            enableFlagDictMap: findItemFromList(this.AddWorkLvScore.enableFlag.impl.dropdownList, this.formData.PaWorkLvScore.enableFlag, 'id'),
            deptPostIdDictMap: findItemFromList(this.AddWorkLvScore.deptPostId.impl.dropdownList, this.formData.PaWorkLvScore.deptPostId, 'id'),
            ...this.formData.PaWorkLvScore
          };
          this.onCancel(true, formData);
          return;
        }
        let paWorkLvScore = this.formData.PaWorkLvScore;
        if (paWorkLvScore.type === 'post') {

        }
        let params = {
          paWorkLvScoreDto: {
            pid: this.pid,
            tid: this.formData.PaWorkLvScore.tid,
            tname: this.formData.PaWorkLvScore.tname,
            gcode: this.formData.PaWorkLvScore.gcode,
            code: this.formData.PaWorkLvScore.code,
            type: this.type,
            name: this.formData.PaWorkLvScore.name,
            detail: this.formData.PaWorkLvScore.detail,
            remark: this.formData.PaWorkLvScore.remark,
            deptPostId: this.formData.PaWorkLvScore.deptPostId,
            lvA: this.formData.PaWorkLvScore.lvA,
            lvB: this.formData.PaWorkLvScore.lvB,
            lvC: this.formData.PaWorkLvScore.lvC,
            lvD: this.formData.PaWorkLvScore.lvD,
            lvE: this.formData.PaWorkLvScore.lvE,
            lvF: this.formData.PaWorkLvScore.lvF,
            sort: this.formData.PaWorkLvScore.sort,
            enableFlag: this.formData.PaWorkLvScore.enableFlag
          }
        };

        PaWorkLvScoreController.add(this, params).then(res => {
          this.$message.success('新增成功');
          this.onCancel(true);
        }).catch(e => {});
      });
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaWorkLvScore: {
          id: undefined,
          pid: undefined,
          tid: undefined,
          tname: undefined,
          gcode: undefined,
          code: undefined,
          type: undefined,
          name: undefined,
          detail: undefined,
          remark: undefined,
          deptPostId: undefined,
          enableFlag: undefined,
          sort: undefined,
          lvA: undefined,
          lvB: undefined,
          lvC: undefined,
          lvD: undefined,
          lvE: undefined,
          lvF: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshAddWorkLvScore();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    // 初始化级联数据
    if (this.supportCascadeAdd === '1' && this.rowData != null) {
      this.formData.PaWorkLvScore = {
        ...this.rowData
      }
    }
  },
  watch: {
  }
}
</script>
